import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useLocales } from '@/locales';
import LanguagePopover from '@/layouts/LanguagePopover';
import { ArrowLeft } from 'lucide-react';

const AuthHeader = () => {
  const navigate = useNavigate();
  const { translate } = useLocales();

  return (
    <div className="flex flex-row items-center justify-between">
      <LanguagePopover />
      <Button
        onClick={() => navigate(-1)}
        variant="ghost"
        className="shadow-[0px_5px_5px_rgba(8,15,52,0.04)] text-[#757575] dark:text-muted-foreground text-sm capitalize"
      >
        <ArrowLeft className="mr-1 w-4 h-4" />
        {translate('Back')}
      </Button>
    </div>
  );
};

export default AuthHeader;
